import * as yup from "yup";
import React, { useState, useContext, useMemo } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";

import CustomButton from "../../kits/CustomButton.tsx";

import ManageArticlesContext from "../../../context/AdminManagement/ManagementContext.jsx";
import useWindowSize from "../../../utils/Uti";
import ColorSchema from "./../../kits/color/index.ts";
import { IoClose } from "react-icons/io5";
// "./../../kits/color/index.ts";
import FirstDetails, {
  translateCategory,
} from "./../../admin-panel/product-management/insert-product/FirstDetails";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FinalDetails from "./../../admin-panel/product-management/insert-product/FinalDetails";
import { useEffect } from "react";
import { isEmpty } from "lodash";
import toast from "react-hot-toast";
import useAxios from "../../../services/useAxios.tsx";
import { pathMaker } from "../../../utils/helperFunctions.js";
import WebInfoContext from "../../../context/WebInfo/WebInfoContext.ts";
const msg = {
  successEdit: "با موفقیت ویرایش شد.",
  successAddPost: "با موفقیت اضافه گردید شد.",
  errorConnection: "ارتباط ناموفق، لطفا اینترنت خود را چک کنید!",
  errorBadResponse: "خطا در ارتباط! به پشتیبانی اطلاع دهید.",
};

const emptyForm = {
  id: "",
  title: "",
  description: "",
  coverImage: "",
  category: "",
  subCategorys: "",
  optionsProduct: [],
  finalDescription: "",
};

const AddEditArticleModal = () => {
  const { width } = useWindowSize();
  const { execute: addPostApi } = useAxios("api/addpost");
  const { execute: updatePostApi } = useAxios("api/updatepost");

  const {
    showModalArticle,
    setShowModalArticle,
    type,
    selectedArticle,
    setUpdater,
  } = useContext(ManageArticlesContext);
  const { categorys } = useContext(WebInfoContext);
  const [categorySelect, setCategorySelect] = useState("");
  const [subCategorySelect, setSubCategorySelect] = useState([]);
  const date = new Date(selectedArticle.mtm * 1000).toLocaleDateString("fa");
  const [files, setFiles] = useState({ cover: {}, file: [] });
  const [editFormData, setEditFormData] = useState({
    title: "",
    description: "",
    coverImage: "",
    category: "",
    subCategorys: "",
    finalDescription: "",
  });
  const schemaProduct = yup
    .object({
      title: yup.string().required("عنوان نباید خالی باشد."),
      description: yup.string().required("توضیحات نباید خالی باشد."),
      finalDescription: yup.string().required("مقاله نباید خالی باشد."),
      category: yup
        .mixed()
        .test("category", "دسته بندی باید انتخاب شود.", (value) => {
          if (!value) return false;
          if (value == "") return false;
          if (value.length < 1) return false;
          return true;
        }),
      subCategorys: yup.mixed(),
      // .test("subCategorys", "زیر دسته باید انتخاب شود.", value => {
      //   if (!value) return false;
      //   if (value == "") return false;
      //   if (value.length < 1) return false;
      //   return true;
      // })
    })
    .required();

  const schemaArticle = yup
    .object({
      title: yup.string().required("عنوان نباید خالی باشد."),
      description: yup.string().required("توضیحات نباید خالی باشد."),
      finalDescription: yup.string().required("مقاله نباید خالی باشد."),
    })
    .required();

  const formController = useForm({
    resolver: yupResolver(schemaProduct),
    values: type === "add" ? { ...emptyForm } : editFormData,
    defaultValues: type === "add" ? { ...emptyForm } : editFormData,
    resetOptions: {
      keepErrors: true,
    },
  });
  const allReset = () => {
    formController.reset();
    formController.resetField("category");
    setFiles({ cover: {}, file: [] });
  };

  // find selected category and subcategory by formcontrol data to show in edit modal
  const findSelectedItems = () => {
    if (type == "add") return;

    let tempSubsSelected = [];
    let tempCategory = {};
    if (
      selectedArticle.hashtags.length > 0 &&
      selectedArticle.hashtags.filter((it) => it.hashtag_status == "0").length >
        0
    ) {
      let categorySelected = selectedArticle.hashtags.filter(
        (it) => it.hashtag_status == "0"
      )[0];
      tempCategory = translateCategory(
        categorys.filter(
          (item) => item.hashtag.id == categorySelected.hashtags_id
        )[0]
      );

      if (tempCategory) {
        let tempSubs = selectedArticle.hashtags.filter(
          (it) => it.hashtag_status != "0"
        );
        if (tempSubs.length > 0) {
          tempSubs.map((it) => {
            if (tempCategory.subs && tempCategory.subs.length > 0) {
              let opt = tempCategory.subs.filter(
                (sub) => sub.value == it.hashtags_id
              )[0];
              tempSubsSelected.push(opt);
            }
          });
        }
      }
    }

    setEditFormData({
      id: selectedArticle.id,
      title: selectedArticle.title,
      description: selectedArticle.description,
      coverImage:
        selectedArticle.file.length !== 0
          ? {
              id: selectedArticle.file[0].id,
              path: pathMaker(selectedArticle.file[0].url),
            }
          : "",
      category: tempCategory,
      subCategorys: tempSubsSelected,
      finalDescription: selectedArticle.bodytxt,
    });

    setFiles({
      cover:
        selectedArticle.file.length !== 0
          ? {
              index: selectedArticle.file[0].id,
              preview: pathMaker(selectedArticle.file[0].url),
              type: "image",
            }
          : "",
    });
  };

  useEffect(() => {
    if (selectedArticle !== "") {
      findSelectedItems();
    }
  }, [selectedArticle, showModalArticle]);

  // watcher form
  useEffect(() => {
    const subscription = formController.watch((value, { name, type }) => {
      if (name == "category" && !isEmpty(value.category)) {
        formController.setValue("subCategorys", []);
      }
    });
    return () => subscription.unsubscribe();
  }, [formController.watch]);

  // onChange Show State
  useEffect(() => {
    if (!showModalArticle) {
      allReset();
      return;
    }
    // setDefaultValue(values);
  }, [showModalArticle]);

  useEffect(() => {
    // console.log("coverImage: ", formController.getValues("coverImage"));
  }, [formController.getValues("coverImage")]);

  const onSubmit = (selectedArticle) => {
    let formData = new FormData();

    if (type == "add") {
      if (files.cover) {
        formData.append("file", files.cover.file);
      } else {
        toast.error("کاور محصول اجباری می باشد.");
        return;
      }
      formData.append("title", selectedArticle.title);
      formData.append("description", selectedArticle.description);
      formData.append("bodytxt", selectedArticle.finalDescription);
      formData.append(
        "addHashtag",
        `${selectedArticle.category.value},${
          selectedArticle.subCategorys.length !== 0
            ? selectedArticle.subCategorys.map((it) => it.value).join(",")
            : ""
        }`
      );
      addPostApi(formData)
        .then((result) => {
          console.log({ result });
          if (result.status == 1) {
            toast.success(msg.successAddPost);
            allReset();
            setUpdater((prev) => !prev);
            setShowModalArticle(false);
          } else {
            toast.error(msg.errorConnection);
          }
        })
        .catch((err) => {
          toast.error(msg.errorConnection);
        });
    } else if (type === "edit") {
      if (files.cover && files.cover.file !== undefined) {
        formData.append("file", files.cover.file);
      } else if (!files.cover && files.cover.index === undefined) {
        toast.error("کاور محصول اجباری می باشد.");
        return;
      }
      formData.append("title", selectedArticle.title);
      formData.append("description", selectedArticle.description);
      formData.append("bodytxt", selectedArticle.finalDescription);
      formData.append(
        "Hashtags",
        `${selectedArticle.category.value},${
          selectedArticle.subCategorys.length !== 0
            ? selectedArticle.subCategorys.map((it) => it.value).join(",")
            : ""
        }`
      );
      formData.append("postId", selectedArticle.id);
      updatePostApi(formData)
        .then((result) => {
          console.log({ result });
          if (result.status == 1) {
            toast.success(msg.successAddPost);
            allReset();
            setUpdater((prev) => !prev);
            setShowModalArticle(false);
          } else {
            toast.error(msg.errorConnection);
          }
        })
        .catch((err) => {
          toast.error(msg.errorConnection);
        });
    }
  };
  return (
    <>
      <Modal
        fullscreen={"xl-down"}
        backdropClassName="show"
        size="xl"
        dialogClassName="w-100 "
        className="insert-product pd-r-0 d-flex justify-content-center overflow-hidden"
        show={showModalArticle}
        // onHide={(e) => setShowModalArticle((prev) => !prev)}
      >
        <Modal.Header>
          <h5 className="font-18-600">
            {type === "add" ? "افزودن مقاله" : `ویرایش مقاله : `}
            {type === "edit" ? (
              <span style={{ fontSize: "14px" }}>{date}</span>
            ) : (
              ""
            )}
          </h5>
          <div
            className="cursor-pointer"
            onClick={() => setShowModalArticle((prev) => !prev)}
          >
            <IoClose
              className="wh-24 text-secondary pointer"
              color={ColorSchema.blue_13}
            />
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: width > 1200 && "calc(100vh - 180px)",
            minHeight: width > 1200 && "calc(100vh - 180px)",
            overflowY: "auto",
          }}
          className="w-100 pd-t-16 pd-x-8 font-14-600 color-bk-04"
        >
          <form
            id="insert-article-form"
            onSubmit={formController.handleSubmit(onSubmit)}
          >
            <Tabs id="insert-article-tab" className="mb-3">
              <Tab eventKey="first-selectedArticle" title="اطلاعات اولیه">
                <FirstDetails
                  files={files}
                  setFiles={setFiles}
                  formControl={formController}
                  article={true}
                />
              </Tab>
              <Tab eventKey="final-details" title="اطلاعات تکمیلی">
                <FinalDetails formControl={formController} />
              </Tab>
            </Tabs>
          </form>
        </Modal.Body>
        <Modal.Footer style={{ padding: "8px 16px" }}>
          <div style={{ margin: 0 }}>
            <CustomButton
              type="submit"
              form="insert-article-form"
              buttonClassName="bg-success wd-80 pd-y-6"
              color={ColorSchema.blue_11}
              textColor={ColorSchema.white}
              onClick={() => {
                let error = [];
                console.log(formController.formState.errors);
                for (let [err, index] of Object.entries(
                  formController.formState.errors
                )) {
                  console.log(err);
                  error.push(index.message);
                }
                if (error.length > 0) toast.error(error[0]);
              }}
            >
              <span className="font-14-600">
                {type == "add" ? "ثبت" : "ویرایش"}
              </span>
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddEditArticleModal;
